import { createContext } from 'react';
import type { EmployeesContextType } from '../types';

export const EmployeesContext = createContext<EmployeesContextType | undefined>(undefined);
